/**
 * MSAL Configuration for Microsoft Entra ID (Azure AD)
 * Aligned with Siemens Entra ID authentication
 */

const clientId = import.meta.env.VITE_AZURE_CLIENT_ID || 'c3cc63d3-06be-4847-b7ee-60d9031cf2a9';
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID || '38ae3bcd-9579-4fd4-adda-b42e1495d55a';

export const msalConfiguration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin + '/',
    postLogoutRedirectUri: window.location.origin + '/login',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

export const AZURE_TENANT_ID = tenantId;
export const AZURE_CLIENT_ID = clientId;
